import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { ProductListComponent } from "./product-list/product-list.component";
import { ProductDetailComponent } from "./product-detail/product-detail.component";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const productsRoutes: Routes = [
  {
    path: "",
    component: ProductListComponent,
  },
  { path: "reset", redirectTo: "product", pathMatch: "prefix" },
  {
    path: "product",
    component: ProductDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "product/:id",
    component: ProductDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(productsRoutes)],
  exports: [RouterModule],
})
export class ProductRoutingModule {}
